import * as React from 'react'
import './Layout.sass'

import Helmet from 'react-helmet'
import { Footer } from '../Footer/Footer'
import { LayoutProps } from './'


const Layout: React.SFC<LayoutProps> = ({ children, footer = true, headers = [] }) => (
  <>
    <Helmet
      title="Let's Enhance – free online image upscale and enhancement. Try neural networks to increase resolution and quality now!"
    >
      <html lang="en" />

      <link rel="apple-touch-icon" sizes="57x57" href="favicon/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="favicon/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="favicon/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="favicon/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="favicon/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="favicon/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="favicon/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="favicon/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="favicon/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192"  href="favicon/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="favicon/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="favicon/favicon-16x16.png" />
      <link rel="manifest" href="favicon/manifest.json" />

      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="favicon/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />

      <meta name="description" content="Free service to upscale and improve your photos and images using state-of-art neural networks." />
      <meta name="keywords" content="enhance images quality improve" />

      <meta property="og:url" content="https://letsenhance.bitbucket.io/public" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Neural network image super-resolution and enhancement" />
      <meta property="og:description" content="Free service to upscale and improve your photos and images using state-of-art neural networks." />
      <meta property="og:image" content="https://letsenhance.io/static/fb1200.png" />

      {headers}
    </Helmet>

    <main>{children}</main>

    { footer && <Footer /> }

  </>
)

export default Layout
